import React from "react"
import { graphql } from "gatsby"

import SEO from "../components/seo"

import SectionedPageContent from '../components/sectionedPageContent/sectionedPageContent'
  
export const query = graphql`
  query SustainabilityQuery {
    prismic {
      allSustainabilitys {
        edges {
          node {
            title
            introduction_text
            background_video {
              ... on PRISMIC__ImageLink {
                _linkType
                url
                width
                height
              }
              ... on PRISMIC__FileLink {
                _linkType
                url
              }
            }
            _meta {
              uid
            }
            body {
              ... on PRISMIC_SustainabilityBodyText_section {
                type
                label
                primary {
                  section_text
                  disable_page_link
                  section_title
                  short_section_title
                  background_image
                }
              }
              ... on PRISMIC_SustainabilityBodyCase_studies {
                type
                label
                fields {
                  case_study {
                    ... on PRISMIC_Case_studies {
                      title
                      _meta {
                        uid
                        type
                      }
                    }
                  }
                }
              }
              ... on PRISMIC_SustainabilityBodyPolicies {
                type
                label
                primary {
                  section_text
                }
                fields {
                  policy {
                    ... on PRISMIC_Policies {
                      title
                      policy_cover_thumbnail
                      _linkType
                      _meta {
                        uid
                        type
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`

const Sustainability = ({ data }) => {
  const doc = data.prismic.allSustainabilitys.edges.slice(0,1).pop();
  if (!doc) return null;

  return (
    <React.Fragment>
      <SEO title="Sustainability" />
      <SectionedPageContent doc={doc} />
    </React.Fragment>
  )
}

export default Sustainability
